document.addEventListener('DOMContentLoaded', () => {
  const printButtons = document.querySelectorAll('[data-resource-hero-print]');
  const progress = document.querySelector('.uk-progress'); // <progress> element (fills %)
  const progressBarContainer = document.querySelector('.progress-bar-container'); // wrapper that slides in
  const firstSection = document.querySelector('.evergreen-section'); // the main content wrapper
  const contentsButton = document.querySelector('.contents-button'); // vertical tab
  const drawer = document.getElementById('scroll-drawer'); // slide-out drawer
  const closeButton = drawer ? drawer.querySelector('.uk-icon-button') : null;

  printButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      window.print();
    });
  });

  if (!firstSection) {
    console.warn('Missing .evergreen-section');
    return;
  }

  //
  // 1. Scroll % fill logic for <progress>
  //
  if (progress) {
    document.addEventListener(
      'scroll',
      () => {
        const scrollTop = window.scrollY;
        const docHeight = document.body.scrollHeight - window.innerHeight;
        const scrollPercent = (scrollTop / docHeight) * 100;
        progress.value = scrollPercent;
      },
      { passive: true }
    );
  }

  //
  // 2. Internal state + helpers
  //
  let barVisible = false;
  let drawerVisible = false; // whether the drawer is currently slid in

  // reading zone calc (same as before)
function getReadingZoneState() {
  const rect = firstSection.getBoundingClientRect();
  const bottomBuffer = 100; // px from bottom of viewport

  // Start reading zone when top of first section reaches top of viewport
  const hasEnteredReadingZone = rect.top <= 0;

  // End reading zone when bottom of section approaches bottom of viewport
  const sectionBottomNearBottom = rect.bottom - bottomBuffer <= window.innerHeight;

  const inReadingZone = hasEnteredReadingZone && !sectionBottomNearBottom;

  return {
    inReadingZone,
    hasEnteredReadingZone,
    sectionBottomNearBottom,
  };
}


  // ---- progress bar helpers ----
  function showBar() {
    if (!progressBarContainer || barVisible) return;
    progressBarContainer.classList.add('is-visible');
    barVisible = true;
  }

  function hideBar() {
    if (!progressBarContainer || !barVisible) return;
    progressBarContainer.classList.remove('is-visible');
    barVisible = false;
  }

  // ---- button helpers ----
  function showButton() {
    if (!contentsButton) return;
    contentsButton.classList.add('is-visible');
  }

  function hideButton() {
    if (!contentsButton) return;
    contentsButton.classList.remove('is-visible');
  }

  // ---- drawer helpers ----
  function openDrawer() {
    if (!drawer) return;
    drawer.style.left = '0';
    drawerVisible = true;
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.style.left = '-360px';
    drawerVisible = false;
  }

  //
  // 3. Click wiring
  //

  // Clicking the vertical button:
  // - show drawer
  // - hide the button (so you don't have both at once)
  if (contentsButton && drawer) {
    contentsButton.addEventListener('click', () => {
      openDrawer();
      hideButton();
    });
  }

  // Clicking the drawer close "X":
  // - close drawer
  // - if we're still in the reading zone, show button again
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      closeDrawer();

      const { inReadingZone } = getReadingZoneState();
      if (inReadingZone) {
        showButton();
      } else {
        hideButton();
      }
    });
  }

  //
  // 4. The main scroll handler
  // This is the single source of truth for visibility of bar/button/drawer as you scroll
  //
  function handleScroll() {
    const { inReadingZone } = getReadingZoneState();

    if (inReadingZone) {
      // We're in the reading zone

      // progress bar should be visible
      showBar();

      // Drawer rule:
      //   - Drawer NEVER auto-appears here; it only appears when user clicks.
      //   - But if it IS currently visible because the user opened it, keep it visible.
      // Button rule:
      //   - If drawer is open, hide the button
      //   - If drawer is closed, show the button
      if (drawerVisible) {
        // drawer is open right now
        hideButton();
      } else {
        // drawer is closed
        showButton();
      }
    } else {
      // We're NOT in the reading zone
      // Everything retracts

      hideBar();
      hideButton();
      closeDrawer(); // drawer should disappear whenever we're out of the zone
    }
  }

  //
  // 5. Bind scroll + run once on load
  //
  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
});

document.addEventListener('DOMContentLoaded', () => {
  const contentsButton = document.querySelector('.contents-button');
  const drawer = document.getElementById('scroll-drawer');
  const firstSection = document.querySelector('.evergreen-section');
  const closeButton = drawer ? drawer.querySelector('.uk-icon-button') : null;

  if (!contentsButton || !drawer || !firstSection) {
    // If any of these are missing, no need to wire up click behavior
    return;
  }

  // We'll track drawer state locally here
  let drawerVisible = false;

  // same reading-zone test you’re using in scroll logic now:
  function inReadingZone() {
    const rect = firstSection.getBoundingClientRect();
    const bottomBuffer = 100; // px from bottom of viewport

    const hasEnteredReadingZone = rect.top <= 0;
    const sectionBottomNearBottom = rect.bottom - bottomBuffer <= window.innerHeight;

    return hasEnteredReadingZone && !sectionBottomNearBottom;
  }

  function openDrawer() {
    drawer.style.left = '0';
    drawerVisible = true;
  }

  function closeDrawer() {
    drawer.style.left = '-360px';
    drawerVisible = false;
  }

  function showButton() {
    contentsButton.classList.add('is-visible');
  }

  function hideButton() {
    contentsButton.classList.remove('is-visible');
  }

  //
  // Click: open drawer from the button
  //
  contentsButton.addEventListener('click', () => {
    // Show drawer
    openDrawer();

    // Hide button while drawer is open
    hideButton();
  });

  //
  // Click: close drawer from inside drawer
  //
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      // Close drawer
      closeDrawer();

      // After closing, we only re-show the button if we're still in the reading zone.
      // If the scroll logic has already hidden the button (e.g. we're above or below the zone),
      // we respect that.
      if (inReadingZone()) {
        showButton();
      } else {
        hideButton();
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('download');
  if (!modal) return;

  const buttons = Array.from(modal.querySelectorAll('a[data-resource-gated-download="1"]'));
  const form = modal.querySelector('form[data-evergreen-forms-proxy="1"]');

  if (!buttons.length || !form) return;

  const gatedFormId = form.id;
  if (!gatedFormId) return;

  const disableButtons = () => {
    buttons.forEach((button) => {
      const href = button.getAttribute('href');
      if (href) button.dataset.gatedHref = href;

      button.removeAttribute('href');
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('tabindex', '-1');
      button.classList.add('is-disabled');
    });
  };

  const enableButtons = () => {
    buttons.forEach((button) => {
      if (button.dataset.gatedHref) {
        button.setAttribute('href', button.dataset.gatedHref);
      }

      button.removeAttribute('aria-disabled');
      button.removeAttribute('tabindex');
      button.classList.remove('is-disabled');
    });
    modal.dataset.resourceDownloadsUnlocked = '1';
  };

  if (modal.dataset.resourceDownloadsUnlocked !== '1') {
    disableButtons();
  }

  window.addEventListener('evergreen:signup:success', (event) => {
    const formId = event?.detail?.formId;
    if (!formId || formId !== gatedFormId) return;
    enableButtons();
  });
});
